import { Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPhone } from 'utils/phone';
import InfoPopup, { DetailItem } from './InfoPopup';

// staffCheck returns a PersonAccessView row: name/district/campus sit on the view itself,
// while contact details and job title hang off the nested person.
export default function StaffEmploymentInfo({ open, onClose, employment }) {
  const { t } = useTranslation();
  const person = employment?.person;
  const address = person?.addresses?.[0];
  const phone = person?.phones?.[0];

  return (
    <InfoPopup
      open={open}
      onClose={onClose}
      title={t('Staff Employment Information')}
      emptyMessage={t('No employment record found for this work email.')}
      hasData={Boolean(employment)}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <DetailItem
            label={t('Staff Name')}
            value={`${employment?.firstName || '—'} ${employment?.lastName || ''}`}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Job Title')} value={person?.jobTitle?.name} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Work Email')} value={person?.email} />
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color="text.secondary">
            {t('Employment Location')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('District')} value={employment?.districtName} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Campus')} value={employment?.campusName} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DetailItem label={t('Phone')} value={phone?.number ? formatPhone(phone.number) : ''} />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color="text.secondary">
            {t('Contact Information')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <DetailItem
            label={t('Address')}
            value={`${address?.street || ''} ${address?.line2 || ''} ${address?.city || ''} ${address?.state || ''} ${address?.zip || ''}`.trim()}
          />
        </Grid>
      </Grid>
    </InfoPopup>
  );
}
